import { call, put, select, takeLatest } from 'redux-saga/effects'
import { setSectionTwoAuthorizedRepresentativeOptions } from '../store/options.actions'
import Logger from '../../../services/logger.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { SignaturesService } from '../../signatures/services/signatures.service'
import { getServiceIdSelector } from '../../user/selectors'
import { SagaIterator } from 'redux-saga'

export function* getAuthorizedRepresentativeOptions(): SagaIterator {
  try {
    const serviceId = yield select(getServiceIdSelector)
    const signaturesService = new SignaturesService(serviceId)
    const response = yield call([signaturesService, signaturesService.getSectionTwoAuthorizedRepresentativeOptions])
    const { entity } = response

    yield put(setSectionTwoAuthorizedRepresentativeOptions(entity))
  } catch (e) {
    Logger.error(`getAuthorizedRepresentativeOptions() error: ${e}`)
  }
}
export function* getAuthorizedRepresentativeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getAuthorizedRepresentativeOptions)
}
